import { createRouter, createWebHistory } from "vue-router";
import store from "@/store/index";
import Swal from "sweetalert2";

const routes = [
  {
    path: "/",
    name: "MainPage",
    component: () => import("@/views/MainPage.vue"),
    // meta: { authRequired: true }
  },
  {
    path: "/site_map.do",
    name: "SiteMap",
    component: () => import("@/views/SiteMap.vue"),
    // meta: { authRequired: true }
  },
  {
    path: "/cp/company02.do",
    name: "Company02",
    component: () => import("@/views/cp/Company02.vue"),
    // meta: { authRequired: true }
  },
  {
    path: "/cp/company03.do",
    name: "Company03",
    component: () => import("@/views/cp/Company03.vue"),
    // meta: { authRequired: true }
  },
  {
    path: "/cp/company04.do",
    name: "Company04",
    component: () => import("@/views/cp/Company04.vue"),
    // meta: { authRequired: true }
  },
  {
    path: "/cp/company05.do",
    name: "Company05",
    component: () => import("@/views/cp/Company05.vue"),
    // meta: { authRequired: true }
  },
  {
    path: "/cp/company06.do",
    name: "Company06",
    component: () => import("@/views/cp/Company06.vue"),
    // meta: { authRequired: true }
  },
  {
    path: "/cp/company07.do",
    name: "Company07",
    component: () => import("@/views/cp/Company07.vue"),
    // meta: { authRequired: true }
  },
  {
    path: "/cp/company08.do",
    name: "Company08",
    component: () => import("@/views/cp/Company08.vue"),
    // meta: { authRequired: true }
  },
  {
    path: "/cp/company09.do",
    name: "Company09",
    component: () => import("@/views/cp/Company09.vue"),
    // meta: { authRequired: true }
  },
  {
    path: "/im/investment01.do",
    name: "Investment01",
    component: () => import("@/views/im/Investment01.vue"),
    // meta: { authRequired: true }
  },
  {
    path: "/im/investment03.do",
    name: "Investment03",
    component: () => import("@/views/im/Investment03.vue"),
    // meta: { authRequired: true }
  },
  {
    path: "/im/investment04.do",
    name: "Investment04",
    component: () => import("@/views/im/Investment04.vue"),
    // meta: { authRequired: true }
  },
  {
    path: "/im/investment05.do",
    name: "Investment05",
    component: () => import("@/views/im/Investment05.vue"),
    // meta: { authRequired: true }
  },
  {
    path: "/im/investment05-view.do",
    name: "Investment05_View",
    component: () => import("@/views/im/Investment05View.vue"),
    // meta: { authRequired: true }
  },
  {
    path: "/im/investment06.do",
    name: "Investment06",
    component: () => import("@/views/im/Investment06.vue"),
    // meta: { authRequired: true }
  },
  {
    path: "/im/investment07.do",
    name: "Investment07",
    component: () => import("@/views/im/Investment07.vue"),
    // meta: { authRequired: true }
  },
  {
    path: "/im/investment08.do",
    name: "Investment08",
    component: () => import("@/views/im/Investment08.vue"),
    // meta: { authRequired: true }
  },
  {
    path: "/ep/employment04.do",
    name: "Employment04",
    component: () => import("@/views/ep/Employment04.vue"),
    // meta: { authRequired: true }
  },
  {
    path: "/ep/employment05.do",
    name: "Employment05",
    component: () => import("@/views/ep/Employment05.vue"),
    // meta: { authRequired: true }
  },
  {
    path: "/ep/employment06.do",
    name: "Employment06",
    component: () => import("@/views/ep/Employment06.vue"),
    // meta: { authRequired: true }
  },
  {
    path: "/ep/employment07.do",
    name: "Employment07",
    component: () => import("@/views/ep/Employment07.vue"),
    // meta: { authRequired: true }
  },
  {
    path: "/cs/cs-center01-list.do",
    name: "CsCenter01List",
    component: () => import("@/views/cs/CsCenter01List.vue"),
    // meta: { authRequired: true }
  },
  {
    path: "/cs/cs-center01-view.do",
    name: "CsCenter01View",
    component: () => import("@/views/cs/CsCenter01View.vue"),
    // meta: { authRequired: true }
  },
  {
    path: "/cs/cs-center02.do",
    name: "CsCenter02",
    component: () => import("@/views/cs/CsCenter02.vue"),
    // meta: { authRequired: true }
  },
  {
    path: "/cs/cs-center03-pp.do",
    name: "CsCenter03Pp",
    component: () => import("@/views/cs/CsCenter03Pp.vue"),
    // meta: { authRequired: true }
  },
  {
    path: "/cs/cs-center03-coe.do",
    name: "CsCenter03Coe",
    component: () => import("@/views/cs/CsCenter03Coe.vue"),
    // meta: { authRequired: true }
  },
  {
    path: "/cs/cs-center03-ci.do",
    name: "CsCenter03Ci",
    component: () => import("@/views/cs/CsCenter03Ci.vue"),
    // meta: { authRequired: true }
  },
  {
    path: "/cs/cs-center03-ec.do",
    name: "CsCenter03Ec",
    component: () => import("@/views/cs/CsCenter03Ec.vue"),
    // meta: { authRequired: true }
  },
  {
    path: "/cs/cs-center03.do",
    name: "CsCenter03",
    component: () => import("@/views/cs/CsCenter03.vue"),
    // meta: { authRequired: true }
  },
  {
    path: "/cs/cs-center04.do",
    name: "CsCenter04",
    component: () => import("@/views/cs/CsCenter04.vue"),
    // meta: { authRequired: true }
  },
  {
    path: "/cs/cs-center05-1.do",
    name: "CsCenter05-1",
    component: () => import("@/views/cs/CsCenter05_1.vue"),
    // meta: { authRequired: true }
  },
  {
    path: "/cs/cs-center05-2.do",
    name: "CsCenter05-2",
    component: () => import("@/views/cs/CsCenter05_2.vue"),
    // meta: { authRequired: true }
  },
  {
    path: "/nice-pass/result",
    name: "NicePassResult",
    component: () => import("@/views/cs/NicePassResultPage.vue"),
  },
  {
    path: "/cs/cs-center06.do",
    name: "CsCenter06",
    component: () => import("@/views/cs/CsCenter06.vue"),
    // meta: { authRequired: true }
  },
  {
    path: "/cs/cs-center07.do",
    name: "CsCenter07",
    component: () => import("@/views/cs/CsCenter07.vue"),
    // meta: { authRequired: true }
  },
  {
    path: "/sv/service01.do",
    name: "Service01",
    component: () => import("@/views/sv/Service01.vue"),
    // meta: { authRequired: true }
  },
  {
    path: "/sv/service02.do",
    name: "Service02",
    component: () => import("@/views/sv/Service02.vue"),
    // meta: { authRequired: true }
  },
  {
    path: "/sv/service03.do",
    name: "Service03",
    component: () => import("@/views/sv/Service03.vue"),
    // meta: { authRequired: true }
  },
  {
    path: "/sv/service04.do",
    name: "Service04",
    component: () => import("@/views/sv/Service04.vue"),
    // meta: { authRequired: true }
  },
  {
    path: "/sv/service05.do",
    name: "Service05",
    component: () => import("@/views/sv/Service05.vue"),
    // meta: { authRequired: true }
  },
  {
    path: "/sv/service06.do",
    name: "Service06",
    component: () => import("@/views/sv/Service06.vue"),
    // meta: { authRequired: true }
  },
  {
    path: "/sv/service07.do",
    name: "Service07",
    component: () => import("@/views/sv/Service07.vue"),
    // meta: { authRequired: true }
  },
  {
    path: "/voucher-request.do",
    name: "voucherRequest",
    component: () => import("@/views/sv/VoucherRequest.vue"),
    // meta: { authRequired: true }
  },
  {
    path: "/sv/service08.do",
    name: "Service08",
    component: () => import("@/views/sv/Service08.vue"),
    // meta: { authRequired: true }
  },
  {
    path: "/pc/pr-center01.do",
    name: "PrCenter01",
    component: () => import("@/views/pc/PrCenter01.vue"),
    // meta: { authRequired: true }
  },
  {
    path: "/admin.do",
    name: "admin",
    component: () => import("@/views/admin/lg/login.vue"),
    meta: { authRequired: true }
  },
  {
    path: "/admin/cs/cs-notice01-list.do",
    name: "notice01List",
    component: () => import("@/views/admin/cs/CsNotice01List.vue"),
    meta: { authRequired: true }
  },
  {
    path: "/admin/cs/cs-notice01-write.do",
    name: "notice01Write",
    component: () => import("@/views/admin/cs/CsNotice01Write.vue"),
    meta: { authRequired: true }
  },
  {
    path: "/admin/cs/cs-notice01-modify.do/:bbsNo",
    name: "notice01Modify",
    component: () => import("@/views/admin/cs/CsNotice01Modify.vue"),
    meta: { authRequired: true }
  },
  {
    path: "/admin/cs/cs-notice01-view.do/:bbsNo",
    name: "notice01View",
    component: () => import("@/views/admin/cs/CsNotice01View.vue"),
    meta: { authRequired: true }
  },
  {
    path: "/admin/pc/pc-presPls01-list.do",
    name: "presPls01List",
    component: () => import("@/views/admin/pc/PcPresPls01List.vue"),
    meta: { authRequired: true }
  },
  {
    path: "/admin/pc/pc-presPls01-write.do",
    name: "presPls01Write",
    component: () => import("@/views/admin/pc/PcPresPls01Write.vue"),
    meta: { authRequired: true }
  },
  {
    path: "/admin/pc/pc-presPls01-view.do/:bbsNo",
    name: "presPls01View",
    component: () => import("@/views/admin/pc/PcPresPls01View.vue"),
    meta: { authRequired: true }
  },
  {
    path: "/admin/im/im-ir01-list.do",
    name: "ir01List",
    component: () => import("@/views/admin/im/ImIr01List.vue"),
    meta: { authRequired: true }
  },
  {
    path: "/admin/im/im-ir01-write.do",
    name: "ir01Write",
    component: () => import("@/views/admin/im/ImIr01Write.vue"),
    meta: { authRequired: true }
  },
  {
    path: "/admin/im/im-ir01-modify.do/:bbsNo",
    name: "ir01Modify",
    component: () => import("@/views/admin/im/ImIr01Modify.vue"),
    meta: { authRequired: true }
  },
  {
    path: "/admin/im/im-ir01-view.do/:bbsNo",
    name: "ir01View",
    component: () => import("@/views/admin/im/ImIr01View.vue"),
    meta: { authRequired: true }
  },
  {
    path: "/admin/cs/cs-minwon01-list.do/:regTyp",
    name: "minwon01List",
    component: () => import("@/views/admin/cs/CsMinwon01List.vue"),
    meta: { authRequired: true }
  },
  {
    path: "/admin/cs/cs-minwon01-view.do/:regSeq",
    name: "minwon01View",
    component: () => import("@/views/admin/cs/CsMinwon01View.vue"),
    meta: { authRequired: true }
  },
  {
    path: "/admin/cs/cs-minwon02-list.do/:regTyp",
    name: "minwon02List",
    component: () => import("@/views/admin/cs/CsMinwon02List.vue"),
    meta: { authRequired: true }
  },
  {
    path: "/admin/cs/cs-minwon02-view.do/:regSeq",
    name: "minwon02View",
    component: () => import("@/views/admin/cs/CsMinwon02View.vue"),
    meta: { authRequired: true }
  },
  // ?�외
  {
    path: "/404",
    name: "404",
    component: () => import("@/views/NotFoundPage.vue"),
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/404",
  },
];


const router = createRouter({
  mode: "history",
  history: createWebHistory(process.env.BASE_URL),
  routes,
});



export default router;
